<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-own'
      :onSelect="chooseLivingOnOwn"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-partner'
      :onSelect="choosePartner"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  computed: {
    questionAnswerData() {
      return this.$store.state.config.questionAnswerData.cohabitingQuestion;
    }
  },
  methods: {
    ...mapMutations([
      'selectIsCohabiting',
      'goToNextPage',
    ]),
    chooseLivingOnOwn: function () {
      this.selectIsCohabiting(false);
      this.goToNextPage();
    },
    choosePartner: function () {
      this.selectIsCohabiting(true);
      this.goToNextPage();
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-own {
  background-image: url('../../assets/questions/co-married.jpg');
}
.lt-fyf-answer-partner {
  background-image: url('../../assets/questions/co-single.jpg');
}
</style>